import { useRoutes } from 'react-router-dom';
import { PATH_LEVEL, USER_TYPE } from 'utils/dataCenter';
// layouts

import useAuth from '../hooks/useAuth';
import { getShopRoutes } from './SHOP';
import { getHeadRoutes } from './HEAD';
import { getHeadquarterRoutes } from './HEADQUARTER';
import { AUTH } from './AUTH';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { REGISTER_SHOP } from './REGISTER';

// import GuestGuard from '../guards/GuestGuard';
// import AuthGuard from '../guards/AuthGuard';

// ----------------------------------------------------------------------

export default function Router() {
    const { navigateRoot } = useAuth();
    const auth = useSelector((state: RootState) => state.auth);
    window.location.replace('https://ceo.toorder.co.kr/');

    function getRootStack() {
        console.log('navigateRoot', navigateRoot);
        console.log('auth', auth);

        switch (navigateRoot) {
            case USER_TYPE.SHOP:
                if (!auth.user.isAgreed) {
                    return REGISTER_SHOP;
                }
                return getShopRoutes(auth.shop);

            case USER_TYPE.HEAD:
            case USER_TYPE.MANAGER:
                return getHeadRoutes(auth.company);
            case USER_TYPE.HEADQUARTER:
                return getHeadquarterRoutes(auth.headquarter);
            default:
                return AUTH;
        }
    }

    return useRoutes(getRootStack());
}
